import React, { useEffect } from 'react';
import TelecommutingReportDataTable from './TelecommutingReportDataTable';

const TelecommutingReportIndex = ({ rrhh }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <TelecommutingReportDataTable rrhh={rrhh} />;
};

export default TelecommutingReportIndex;
